import { faFileInvoiceDollar } from '@fortawesome/pro-duotone-svg-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useParams } from 'react-router';
import styled from 'styled-components';
import { AddButton } from 'components/atoms/button';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';

interface Props {
  refType: string;
  refId: number;
}

const StyledEmptyStateContainer = styled(EmptyStateContainer)`
  padding: var(--spacing-11);
  height: 100%;
`;

export const KeyEventsEmptyState: React.FC<Props> = ({ refId, refType }) => {
  const { templateId } = useParams<{ templateId: string }>();
  const history = useHistory();

  const onClick = () => {
    history.push(
      `/templates/projects/${
        templateId ?? 'new'
      }/automations/${refType}/${refId}`,
    );
  };

  return (
    <StyledEmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faFileInvoiceDollar} />}
        title={<FormattedMessage id="key_events.empty_state.title" />}
        message={<FormattedMessage id="key_events.empty_state.sub_title" />}
        secondaryCTA={
          <AddButton onClick={onClick}>
            <FormattedMessage id="templates.tab.key_events.add" />{' '}
          </AddButton>
        }
      />
    </StyledEmptyStateContainer>
  );
};
